import script from "./Futures&Parents.vue?vue&type=script&setup=true&lang=js"
export * from "./Futures&Parents.vue?vue&type=script&setup=true&lang=js"

import "./Futures&Parents.vue?vue&type=style&index=0&id=61486d1d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61486d1d"]])

export default __exports__